// extracted by mini-css-extract-plugin
export default {"people-condensed-list__person-icon":"styles_people-condensed-list__person-icon__VSp9L"};